<!-- 

Test credit card numbers

4242 4242 4242 4242 	Visa
5555 5555 5555 4444 	Mastercard
3782 822463 10005 	  Am Ex
6011 1111 1111 1117 	Discoverv
3056 9309 0259 04 	  Diners Club
3566 0020 2036 0505 	JCB
6200 0000 0000 0005 	UnionPay

-->

<script>

import HappyHolidaysTop from "./HappyHolidaysTop.vue";
import HappyHolidaysLeft from "./HappyHolidaysLeft.vue";
import CheckoutForm from "../CheckoutForm.vue";
import Footer from "../../Footer.vue";

export default {
  name: "HappyHolidaysComponent",
  page: {
    title: "Exclusive Offer - 30% Off",
    meta: [
      { name: "description", content: "Exclusive - 30% OFF." },
    ],
  },
  components: {
    HappyHolidaysTop,
    HappyHolidaysLeft,
    CheckoutForm,
    Footer,
  },
  props: {
    HappyHolidaysType: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      guaranteeImg: "ssl-cancel-anytime.jpg",
      expirationDate: new Date("05 October 2024 23:59:59 PST"),
    }
  },
  computed: {
    expirationDateComputed() {
      try {
        const tp = this.$route.query.tp;
        // Check if tp exists and is valid
        if (!tp || tp === 'undefined') {
          throw new Error('Missing or undefined tp parameter');
        }

        // Convert tp to a number
        const timestamp = Number(tp);
        if (isNaN(timestamp)) {
          throw new Error('Invalid tp parameter: not a number');
        }

        return timestamp * 1000; // Convert seconds to milliseconds
      } catch (error) {
        console.error('Error in expirationDateComputed:', error.message);
        return 1;
      }
    }
  },
  methods: {
    getCurrentTimestampPlusXDays(daysToAdd) {
      const defaultDate = new Date();
      defaultDate.setDate(defaultDate.getDate() + daysToAdd);
      return defaultDate.getTime();      
    }
  },
};
</script>

<template>
  <b-container
    style="font-family: url('@/assets/fonts/Cantarell-Regular.ttf')"
  >
    <b-row>
      <b-col sm="12" class="logo-row header-checkout">
        <HappyHolidaysTop :expirationDate="expirationDateComputed"/>
      </b-col>
    </b-row>
    <b-row class="checkout-content">
      <b-col sm="12" lg="6" class="content" style="text-align: left">
        <HappyHolidaysLeft />
      </b-col>
      <b-col sm="12" lg="6" class="checkout">
        <CheckoutForm :loadCombos="[53]" 
                      :guaranteeImg="guaranteeImg"
                      :changeBus="this"
                      :expirationDate="expirationDateComputed"
        />
      </b-col>
    </b-row>
    <Footer />
  </b-container>
</template>

<style lang="scss">
@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Light.ttf);
  font-weight: 200;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Regular.ttf);
  font-weight: 400;
}

@font-face {
  font-family: OpenSans;
  src: url(../../../assets/fonts/OpenSans-Bold.ttf);
  font-weight: 600;
}

// Global Settings
$font-family: "OpenSans";
$font-bold: 700;

// Form Settings
$border-input: 1px solid #f7f7f7;
$bg-input: #f7f7f7;
$color-input: #000000;
$font-size-input: 18px;
$color: #000000;
$line-height-input: 23px;
$padding-input: 15px 18px 15px 55px;
$link-color: #68a432;

// Icon Settings
$icon-color: #999999;

* {
  font-family: $font-family;
}

.alert-error {
  color: #ff0000;
  font-size: 16px;
  margin: 0 !important;
  padding: 0 !important;
  text-align: center;
}

.header-checkout {
  text-align: center;
  h2 {
    font-size: 36px !important;
    font-weight: 300;
    color: #999999 !important;
  }
}
@media screen and (min-width: 481px) {
  .header-checkout:before {
    content: url(../../../assets/images/img-icons.png);
    position: absolute;
    right: 0;
    pointer-events: none;
  }
}

.boxCheckout {
  background-color: #ffffff;
  border: 1px solid #aaaaaa;
  padding: 60px 15px 30px;
  text-align: left;
  .box-login,
  .after-login {
    margin: 0 auto 30px;
    max-width: 415px;
  }
}

form {
  font-family: $font-family;
  font-size: $font-size-input;
  margin: auto;
  max-width: 415px;
  width: 100%;
  .input-group {
    margin: 0 0 8px 0;
    .formIcons {
      position: absolute;
      top: 1px;
      left: 1px;
      width: 57px;
      line-height: 53px;
      z-index: 100;
      svg {
        font-size: 16px;
        position: relative;
        z-index: 100;
        width: 57px;
        path {
          fill: $icon-color;
        }
      }
      &.email,
      &.password,
      &.coupon,
      &.creditcard {
        svg {
          font-size: 20px;
        }
      }
    }
    input {
      background: $bg-input;
      background-image: none !important;
      border: $border-input;
      border-radius: 6px !important;
      color: $color-input;
      font-size: $font-size-input;
      height: auto;
      line-height: $line-height-input;
      padding: $padding-input;
      &:focus {
        background-color: #ffffff;
        border: 1px solid #dcdcdc;
      }
    }
    .form-control {
      &:focus,
      .is-invalid,
      .is-valid {
        box-shadow: none;
      }
    }
    .invalid-feedback-custom {
      color: darkred;
    }
    .email-exist {
      margin-top: 0.25rem;
      font-size: 80%;
      color: #dc3545;
      a {
        color: #509610;
      }
    }
    .discount-apply {
      align-self: center;
      color: $color;
      cursor: pointer;
      font-size: 14px;
      font-weight: $font-bold;
      line-height: 36px;
      position: absolute;
      right: 35px;
      z-index: 99;
    }
    .discount-price {
      align-self: center;
      color: $color;
      font-weight: $font-bold;
      position: absolute;
      right: 0;
      .remove-coupon {
        cursor: pointer;
        display: inline-block;
        font-size: 24px;
        padding: 0px 11px;
        transform: rotate(45deg);
        -ms-transform: rotate(45deg);
      }
    }
  }
}
form {
  .radio-products {
    display: flex;
    flex-direction: column;
    margin: 30px 0 10px;
    padding: 0 15px;
    width: 100%;
    /*label.custom-control-label[for="__BVID__27_BV_option_1"] > span:after {
      display: block;
      content: "Recommended - 14% Off";
      color: #509610;
      font-size: 14px;
      width: 100%;
    }*/
    .custom-control {
      padding-left: 35px;
    }
    input {
      &:focus ~ label {
        &::before {
          box-shadow: none !important;
        }
      }
      &:checked ~ label {
        &::after {
          top: 9px;
          left: -29px;
          width: 9px;
          height: 9px;
          border-radius: 50%;
          background: #ffffff !important;
        }
        &::before {
          background: $link-color !important;
        }
      }
    }
    label {
      cursor: pointer;
      margin-bottom: 12px;
      width: 100%;
      &:hover {
        &::before,
        &::after {
          background-color: #949494 !important;
        }
      }
      &::before,
      &::after {
        background-color: #d9d9d9 !important;
        border: 0;
        border-radius: 50%;
        height: 21px;
        left: -35px;
        top: 3px;
        width: 21px;
      }
      .price {
        font-weight: $font-bold;
        float: right;
      }
      .recommended {
        color: #79b867;
        font-size: 0.8em;
        font-weight: $font-bold;
      }
    }
  }
}
form {
  .card {
    background-color: #ffffff;
    border: 2px solid #e6e6e6;
    border-radius: 0;
    margin: 11px 0 50px 0;
    padding: 18px;
    text-align: center;
    width: 100%;
    .card-title {
      color: $color;
      font-size: 24px;
      font-weight: 700;
      line-height: 40px;
      margin: 0;
    }
    .first-payment-date {
      font-size: 12px;
      line-height: 24px;
    }
    .order-total {
      color: $color;
      font-size: 14px;
      margin: 0;
      .vat-text:hover {
        .vat-details {
          display: block;
          position: absolute;
          right: -150px;
        }
      }
      .underline {
        color: $link-color;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
    }
    .vat-details {
      background: #ffffff;
      border: 1px solid #cbcbcb;
      display: none;
      max-width: 280px;
      padding: 15px 20px 10px;
      text-decoration: none;
      width: 100%;
      z-index: 99;
      p {
        color: $color;
        font-size: 16px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        text-align: left;
        width: 100%;
        &:hover {
          text-decoration: none;
        }
        span {
          color: $color;
          float: right;
        }
      }
      .total {
        border-top: 1px solid #cbcbcb;
        margin-top: 5px;
        p {
          color: $link-color;
          font-weight: 700;
          line-height: 40px;
          span {
            color: $link-color;
          }
        }
      }
    }
  }
}
form {
  img.payments,
  img.secure-ssl {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 80%;
  }
  img.secure-ssl {
    padding: 25px 0;
    &:after {
      content: "";
      border-bottom: 1px solid #cbcbcb;
    }
  }
  .hide-radio-payments {
    padding: 0;
    label {
      &:before,
      &:after {
        display: none;
      }
    }
  }
}

.img-payment {
  margin-bottom: 20px;
  max-width: 254px;
  width: 100%;
}

.paymentInput {
  background: #f7f7f7;
  border: 1px solid #f7f7f7;
  border-radius: 6px;
  .StripeElement--focus {
    outline: none;
    box-shadow: none;
  }
  &.input-group {
    svg {
      font-size: 20px;
      path {
        fill: #999999;
      }
    }
  }
  .input-group-text {
    background: transparent;
    border: 0;
    line-height: 41px;
    width: 57px;
  }
  .form-control {
    background: #f7f7f7 !important;
    border: 0;
    height: auto;
    line-height: 41px;
    align-self: center;
  }
  .card-label {
    text-align: center;
    width: 100%;
  }
}

//STRIPE ELEMENTS
.stripe-element-container {
  align-items: center;
  background: #f7f7f7 !important;
  display: grid;
}
.StripeElement--focus {
  box-shadow: 0;
}

//MODAL
#modalLogin,
#modalRecoverPassword {
  .modal-dialog {
    max-width: 575px;
    .modal-content {
      border: 0;
      border-radius: 0;
      h2 {
        color: #000000;
        font-size: 36px;
        font-weight: 700;
        margin-bottom: 35px;
        padding-top: 60px;
        text-align: center;
        text-transform: uppercase;
        width: 100%;
      }
      p {
        color: #000000;
        max-width: 360px;
        margin: 0 auto 25px;
        text-align: center;
        font-size: 18px;
      }
      .modal-header {
        border: 0;
        padding-top: 15px;
        flex-direction: column;
        p {
          color: #000000;
          font-size: 18px;
          margin: 0 auto;
          max-width: 360px;
          padding-top: 15px;
          text-align: center;
        }
      }
      .modal-footer {
        border: 0;
        padding-top: 0;
        padding-bottom: 65px;
        text-align: center;
      }
      .button-login {
        background: #79b867;
        border: 1px solid #79b867;
        border-radius: 50px;
        color: #ffffff;
        font-size: 20px;
        font-weight: 700;
        line-height: 53px;
        margin-top: 35px;
        padding: 0 15px;
        text-transform: uppercase;
        width: 100%;
        .spinner-border {
          vertical-align: middle;
        }
        &:hover {
          background: #000000;
          border-color: #000000;
          color: #ffffff;
        }
        &:focus {
          outline: none;
        }
      }
      .forgot-password {
        color: #666666;
        font-size: 13px;
        width: 100%;
      }
      .support {
        font-size: 14px;
        text-align: center;
        display: block;
        margin: 35px 0 30px;
        &:hover {
          color: #79b867;
          text-decoration: none;
        }
      }
    }
  }
}

#modalRecoverPassword {
  .modal-dialog {
    .modal-content {
      h2 {
        margin-bottom: 15px;
      }
      .button-login {
        margin-top: 25px;
      }
      .support {
        margin-bottom: 50px;
      }
    }
  }
}

@media screen and (max-width: 639px) {
  #modalLogin,
  #modalRecoverPassword {
    .modal-header {
      padding-top: 55px !important;
      h2 {
        font-size: 18px;
      }
    }
    .modal-footer {
      padding-top: 25px !important;
    }
    .button-login {
      font-size: 18px !important;
    }
  }
}

.checkout-checkbox {
  color: $color;
  font-size: 16px;
  padding: 0 15px;
  a {
    color: $link-color !important;
  }
  .custom-checkbox {
    padding-left: 35px;
    .custom-control-input.is-valid ~ .custom-control-label {
      color: $link-color;
    }
    .custom-control-label {
      cursor: pointer;
      &:hover {
        &::before {
          background: #949494;
        }
      }
      &::after,
      &::before {
        border-radius: 0;
        height: 21px;
        left: -35px;
        top: 1px;
        width: 21px;
      }
      &::before {
        background: #d9d9d9;
        border: 0;
      }
    }
    .custom-control-input:checked ~ .custom-control-label::before {
      border-color: #68a432;
      background-color: #68a432;
    }
    .custom-control-input:focus ~ .custom-control-label::before,
    .custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
      border: 0;
      box-shadow: none;
    }
  }
}

.b-toast {
  width: 100%;
  max-width: 100%;
}

#paymentErrorBox {
  width: 100%;
  max-width: 100%;
  border: 0;
  background-color: #ffebeb;
  border-radius: 0;
  box-shadow: none;
  text-align: center;
  font-size: 18px;
  color: #ff0000;
  line-height: 24px;
  padding: 10px 15px;
}

.textGDPR {
  color: $color;
  font-size: 16px;
  margin: 30px 0;
  text-align: center;
}

.support {
  color: #666666;
  font-size: 16px;
  b {
    &:hover {
      color: #666666;
    }
  }
  a {
    color: #666666;
    &:hover {
      color: $link-color;
    }
  }
  &:hover {
    color: #666666;
  }
}

.logo-row {
  margin: 65px 0 0;
  .logoCheckout {
    width: 100%;
    max-width: 228px !important;
    margin: 0 auto;
  }
}
.call-to-action {
  margin: 50px 0 70px;
}
.call-to-action h2 {
  font-family: "OpenSans";
  font-size: 36px;
  color: #999999;
  text-transform: uppercase;
  line-height: 1.3;
}
h2.form-header {
  color: $color;
  font-size: 24px;
  font-weight: $font-bold;
  margin-bottom: 15px;
  text-transform: uppercase;
}

.twoColumn {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
}
.button-checkout {
  background: #ff0000;
  color: #ffffff;
  border: none;
  border-radius: 30px;
  width: 100%;
  font-size: 20px;
  text-transform: uppercase;
  padding: 15px;
  line-height: 25px;
}

.button-checkout:hover {
  background: #89c157 !important;
}

.button-checkout:active,
.button-checkout:focus {
  background: #ff0000 !important;
  color: #ffffff !important;
  border-color: #ff0000 !important;
  box-shadow: none !important;
  outline: none;
}
.button-checkout:disabled {
  background: red !important;
  color: white;
}

ul.benefits li {
  list-style: none;
  line-height: 56px;
  font-size: 20px;
}

ul.benefits li {
  list-style: none;
  line-height: 56px;
  font-size: 20px;
}

ul.benefits li svg {
  font-size: 33px;
  margin-right: 5px;
  vertical-align: middle;
}

ul.benefits li:nth-child(1) svg {
  color: #5f1e5e;
}

ul.benefits li:nth-child(2) svg {
  color: #8c329c;
}

ul.benefits li:nth-child(3) svg {
  color: #df38c2;
}

ul.benefits li:nth-child(4) svg {
  color: #de2b7f;
}

ul.benefits li:nth-child(5) svg {
  color: #d81a1a;
}

ul.benefits li:nth-child(6) svg {
  color: #f07421;
}

ul.benefits li:nth-child(7) svg {
  color: #fcb51c;
}

ul.benefits li:nth-child(8) svg {
  color: #f4ea25;
}

ul.benefits li:nth-child(9) svg {
  color: #c9ff39;
}

ul.benefits li:nth-child(10) svg {
  color: #84e75c;
}

ul.benefits li:nth-child(11) svg {
  color: #22d949;
}

.textMoneyback {
  color: #434343;
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 19px;
  margin-top: 50px;
}

.text-riskFree {
  font-size: 18px;
  color: #434343;
  margin-bottom: 70px;
}

.testimonials {
  background: transparent;
  margin-bottom: 20px;
  padding: 40px 45px;
  img {
    margin-bottom: 25px;
    max-width: 80px;
  }
  p {
    color: #545454;
    font-size: 20px;
    line-height: 30px;
    img {
      margin: 0;
    }
  }
  .nomargin {
    margin: 0;
  }
  .testimonials-box {
    display: flex;
    align-items: center;
    img {
      align-self: center;
      margin-right: 30px;
    }
  }
  .testimonials-info {
    color: #545454;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-weight: 400;
    line-height: 18px;
    max-width: 300px;
    .testimonials-name {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 5px;
    }
  }
}

.testimonials-background {
  background: #f7f7f7;
}


/* Padding for Stripe Element containers */
.stripe-element-container {
  padding-top: 0.55rem;
  padding-bottom: 0.5rem;
}

/* Blue outline on focus */
.StripeElement--focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

/* Can't see what I type without this */
#card-number.form-control,
#card-cvc.form-control,
#card-exp.form-control {
  display: inline-block;
}
.sr-field-error {
  color: tomato;
}
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: maroon;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: var(--accent-color);
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: var(--accent-color);
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.card-label {
  width: 8ch;
  text-align: right;
  font-family: "OpenSans";
}

@media screen and (max-width: 359px) {
  form {
    .radio-products {
      padding: 0;
    }
  }
}

@media screen and (max-width: 767px) {
  form {
    font-size: 16px;
    .input-group {
      input {
        font-size: 16px;
      }
      .custom-control-inline {
        margin: 0;
      }
    }
  }
  .button-checkout {
    font-size: 18px;
  }
  .checkout-checkbox {
    padding: 0;
  }
  .boxCheckout {
    border: 0;
    padding: 0;
  }
  .call-to-action h2 {
    font-size: 22px;
  }
  ul.benefits {
    margin: 0 !important;
    padding: 40px 0 0 0;
  }
  ul.benefits li {
    margin: 0;
    font-size: 15px;
    line-height: 40px;
  }
  ul.benefits li svg {
    font-size: 23px;
  }
  .testimonials {
    padding: 20px 25px;
    p {
      font-size: 16px;
      line-height: 25px;
    }
  }
  .textMoneyback {
    font-size: 20px;
  }
  .text-riskFree {
    font-size: 13px;
  }
  .footer {
    padding: 60px 0 40px;
    a {
      font-size: 13px;
      margin: 0 15px;
    }
  }
}

@media screen and (max-width: 991px) {
  .hideDesktop {
    margin: 20px -15px;
    max-width: 360px;
    width: calc(100% + 30px);
  }
  .text-riskFree {
    margin-bottom: 0;
  }
}

@media screen and (min-width: 992px) {
  ul.benefits {
    margin-top: 600px;
  }
  .hideDesktop {
    display: none;
  }
}

@media screen and (max-width: 1365px) {
  form {
    .card {
      .order-total {
        .vat-text:hover {
          .vat-details {
            right: -10px;
          }
        }
      }
    }
  }
}
</style>

<!-- to mantain styles scoped on its own components -->
<style lang="scss" scoped>
.content {
  // background: url(../../../assets/images/happy-holidays/happy-holidays-background.jpg) no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: 98% 85%;
}
</style>
